import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import { Gender } from 'interfaces';

export type Staff = {
  staff_id?: number; // 직원 idx,
  shop_information_id?: number; // 쇼/브/매/지 idx
  staff_name?: string; // 직원명
  staff_phone?: string; // 직원 연락처
  staff_time_price?: number; // 시급
  staff_work_time?: string; // 근무시간
  staff_position?: string; // 직급
  staff_gender?: (typeof Gender)[keyof typeof Gender]; // 성별
  birthday?: number; // 생년월일
  hire_date?: number; // 입사일
  termination_date?: number; // 퇴사일
  work_type?: string; // 담당업무
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Staff
   * --
   */
  getStaffs: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_STAFF, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Staff
   * --
   */
  getStaff: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_STAFF, { staff_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Staff
   * --
   */
  createStaff: async (body: Staff) => {
    try {
      const res = await $http.post(APIConstant.CREATE_STAFF, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Staff
   * --
   */
  updateStaff: async (body: Staff) => {
    try {
      const { staff_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_STAFF, {
        staff_id: staff_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Staff
   * --
   */
  deleteStaff: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_STAFF, {
        staff_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
